import api from "@/api";
export default class UserClass {
  constructor(rawdata = {}) {
    this.__required = ["firstname", "lastname", "email", "user_type"];
    this.id = rawdata.id ? rawdata.id : 0;
    this.username = rawdata.username ? rawdata.username : "";
    this.first_name = rawdata.first_name ? rawdata.first_name : "";
    this.last_name = rawdata.last_name ? rawdata.last_name : "";
    this.email = rawdata.email ? rawdata.email : "";
    // this.is_superuser = rawdata.is_superuser ? rawdata.is_superuser : false;
    // this.is_staff = rawdata.is_staff ? rawdata.is_staff : false;
    // this.is_active = rawdata.is_active ? rawdata.is_active : false;
    this.user_type = rawdata.user_type ? rawdata.user_type : "";
    this.update_password = rawdata.update_password
      ? rawdata.update_password
      : false;
    this.password = rawdata.password ? rawdata.password : "";
    this.c_password = rawdata.c_password ? rawdata.c_password : "";
    this.url = rawdata.url ? rawdata.url : "";
    this.signature = rawdata.signature ? rawdata.signature : "";
  }

  static async list(params) {
    const result = await api.get(`/api/v1/users/index/`, params);
    if (result && result.status == 200) return result.data;
    else return null;
  }

  static async fetch(payload) {
    const result = await api.get(`/api/v1/users/info/${payload}/`);
    if (result && result.status == 200) return result.data.data[0];
    else return null;
  }

  static async create(payload) {
    const result = await api.post(`/api/v1/users/create/`, payload);
    if (result && result.status == 200) return result.data.data;
    else return null;
  }

  static async put(payload) {
    var user = new this(payload);
    if (!payload.update_password) delete user.update_password;
    const result = await api.put(`/api/v1/users/${payload.id}/`, user);
    if (result && result.status == 200) return result.data.data;
    else return null;
  }

  static async reinstate(payload) {
    const result = await api.put(`/api/v1/users/status/${payload.id}/`, {
      status: payload.status
    });
    if (result && result.status == 200) return result.data.data;
    return null;
  }

  static rules() {
    return {
      first_name: [
        { required: true, message: "Firstname is required.", trigger: "blur" }
      ],
      last_name: [
        { required: true, message: "Lastname is required.", trigger: "blur" }
      ],
      username: [
        { required: true, message: "Username is required.", trigger: "blur" }
      ],
      email: [
        { required: true, message: "Email is required.", trigger: "blur" },
        { type: "email", message: "Enter a valid email.", trigger: "change" }
      ],
      user_type: [
        { required: true, message: "User type is required.", trigger: "blur" }
      ]
    };
  }

  isRole(param) {
    let res = false;
    if (Array.isArray(param) && param.find(o => o == this.user_type)) {
      res = true;
    } else {
      if (this.user_type == param) {
        res = true;
      }
    }
    return res;
  }
}
